import React, {useContext, useMemo} from 'react';
import useStreamActionsSingle from "../../hooks/useStreamActionsSingle";
import classNames from "classnames";
import AppContext from '../../store/index';
import LogoStore from '../../assets/images/MIFCOM_Logo.svg';
import LogoGOMLVL from '../../assets/images/logo_goml.svg';
import PropTypes from 'prop-types';
import useViewMode from "../../hooks/useViewMode";
import './Header.scss';
import {SYSTEM_ID_TOGGLE_DESK_CAMERA} from "../../contants/presets";
// import useScreenOrientationExtended from "../../hooks/useScreenOrientationExtended";
import useDeviceSizeDetect from "../../hooks/useDeviceSizeDetect";

const TEXT_DEFAULT = "KONFIGURATOR";
const TEXT_DESK_CAMERA = "TISCHANSICHT BEENDEN";

export default function Header(props) {
  const {
    streamStore,
    isStickyPanelCollapsed,
  } = useContext(AppContext);
  // const {isLandscape, isPortrait} = useScreenOrientationExtended();
  const detectMobile = useDeviceSizeDetect();
  const emitter = useStreamActionsSingle();
  
  const handleCloseDeskCamera = () => {
    emitter.emit({
      id: SYSTEM_ID_TOGGLE_DESK_CAMERA,
      data: 0,
    })
  }
  
  const textHeader = useMemo(() => {
    return streamStore[SYSTEM_ID_TOGGLE_DESK_CAMERA] ? TEXT_DESK_CAMERA : TEXT_DEFAULT
  }, [streamStore[SYSTEM_ID_TOGGLE_DESK_CAMERA]])

  /*@TODO IPhone issue*/
  // const isVisibleDesktopOnly = useMemo(() => {
  //   return detectMobile.isDesktop || (detectMobile.isMobile && isLandscape)
  // }, [detectMobile, isLandscape]);
  
  return (
    <div className={classNames(['header-wrapper container-inner', props.className])}>
      <div className="header-container">
        <div className="header-logoStore">
          <img src={LogoStore} alt="MIFCOM logo" />
        </div>
  
        
          <div className={classNames(['header-logoProject', 'visible-device-big'], {
            'collapsed': !isStickyPanelCollapsed,
          })}>
            <img src={LogoGOMLVL} alt="GetOnMyLevel logo" />
          </div>

        {
          detectMobile.isDesktop &&
          <div className="header-textwrap">
            <div className="header-text">
              {textHeader}
            </div>
            {
              streamStore[SYSTEM_ID_TOGGLE_DESK_CAMERA]
                ? <i
                  onClick={handleCloseDeskCamera}
                  className="icon-close close-desk-camera">&nbsp;
                </i>
                : ''
            }
          </div>
        }
        
      </div>
    </div>
  )
}

Header.propTypes = {
  className: PropTypes.string,
}